import { GridItem, Text, Grid } from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

import { FormModal } from "./FormModal";

type RequestDetailsModalProps = {
  onSubmit: () => void;
  onBack: () => void;
  onClose: () => void;
};

export function DeleteAccountWarningModal({
  onSubmit,
  onBack,
  onClose,
}: RequestDetailsModalProps) {
  const { t } = useTranslation();

  return (
    <FormModal
      title={t("Delete your account")}
      onSubmit={onSubmit}
      onCancel={onBack}
      onClose={onClose}
      continueText={t("Continue")}
      secondaryText={t("Cancel")}
      variant="danger"
    >
      <Grid form>
        <GridItem>
          <Text color="text-weak">
            <Trans>
              Deleting your account means you will no longer have access to your
              Certn profile or account and all your data will be deleted. Access
              to any background check invites, and any historical background
              check information will be lost within the next 24 hours. Pressing
              continue will also result in the deletion of any data shared with
              3rd parties. The data deletion may take up to 30 days. Please
              contact privacy@certn.co if you have any questions.
            </Trans>
            <br />
            <br />
            <Trans>Do you want to continue?</Trans>
          </Text>
        </GridItem>
      </Grid>
    </FormModal>
  );
}
